import { Place } from '../types/place';
import BaseEntityService from './baseEntityService';

const serviceUrlSuffix = 'v1/places';

class PlaceService extends BaseEntityService<Place> {
    constructor() {
        super(serviceUrlSuffix);
    }
}

export const placeService = new PlaceService();
